export default {
  payData: {},
  payStart (data, cb) {
    this.payData = Object.assign(data)
    console.log(this.payData, 'payData')
    // 保住原有cb的this指向
    this.payCb = (res) => {
      cb && cb(res)
    }

    if (typeof WeixinJSBridge == "undefined"){
      if( document.addEventListener ){
        document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
      } else if (document.attachEvent){
        document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady); 
        document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
      }
    }else{
      this.onBridgeReady()
    }
  },
  onBridgeReady () {
    WeixinJSBridge.invoke('getBrandWCPayRequest', this.payData, (res) => {
      this.payCb && this.payCb(res)
    })
  },
  payCb: null
}